/**
* Marquee Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Marquee Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'marquee-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.marquee-hero__splide' ).length ) {
        $( '.marquee-hero__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            autoWidth: true,
            direction: 'ltr',
            perPage: 3,
            arrows: false,
            pagination: false,
            drag: false,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'marquee-hero', COMPONENT );
} )( app );
